import Vue from 'vue';
import router from '@/router';
import "./plugins/vuetify-mask";
import { VueMaskDirective } from "v-mask";
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import App from './App';
import '@/filters/filters';

Vue.directive("mask", VueMaskDirective);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
